import { defineMessages } from 'react-intl';

import { OrderDeliveryMethod } from '../../api/Owner/getFullOwnerProductQuery';

export const orderDeliveryMethodMessages = defineMessages({
  [OrderDeliveryMethod.CLICK_AND_COLLECT]: {
    id: 'general.orderDeliveryMethod.ClickAndCollect',
    defaultMessage: 'Click and Collect',
  },
  [OrderDeliveryMethod.HOME_DELIVERY]: {
    id: 'general.orderDeliveryMethod.HomeDelivery',
    defaultMessage: 'Home Delivery',
  },
  [OrderDeliveryMethod.IN_STORE_PICKUP_DELIVERY]: {
    id: 'general.orderDeliveryMethod.InStorePickUpDelivery',
    defaultMessage: 'In-Store Pickup',
  },
  [OrderDeliveryMethod.LOCAL_PICKUP_DELIVERY]: {
    id: 'general.orderDeliveryMethod.LocalPickUpDelivery',
    defaultMessage: 'Local Pickup',
  },
  [OrderDeliveryMethod.NOT_SET]: {
    id: 'general.orderDeliveryMethod.NotSet',
    defaultMessage: 'Not Set',
  },
  [OrderDeliveryMethod.RESERVE_AND_COLLECT]: {
    id: 'general.orderDeliveryMethod.ReserveAndCollect',
    defaultMessage: 'Reserve and Collect',
  },
  [OrderDeliveryMethod.SCHEDULED_DOORSTEP_DELIVERY]: {
    id: 'general.orderDeliveryMethod.ScheduledDoorstepDelivery',
    defaultMessage: 'Scheduled Doorstep Delivery',
  },
  [OrderDeliveryMethod.SCHEDULED_IN_HOME_DELIVERY]: {
    id: 'general.orderDeliveryMethod.ScheduledInHomeDelivery',
    defaultMessage: 'Scheduled In-Home Delivery',
  },
  [OrderDeliveryMethod.TAKEN_AWAY]: {
    id: 'general.orderDeliveryMethod.TakenAway',
    defaultMessage: 'Taken Away',
  },
});
